import OverlayBase from "../overlay/OverlayBase";
import {useState} from "react";
import SvgLoader from "../../../svg/SvgLoader";
import {rpc_unbanPlayer} from "../rpc";
import {useSocket} from "../SocketContext";

export default function UnbanOverlay(props: { playerName: string, playerSteamId: string, hide: () => void }){

    const [loading, setLoading] = useState<boolean>(false)

    const [error, setError] = useState<string>("")

    const socket = useSocket()

    const handleBan = async () => {
        if (loading){
            return
        }
        setError("")
        setLoading(true)

        const result = await rpc_unbanPlayer(socket, props.playerSteamId)

        setLoading(false)

        if (result.success){
            props.hide()
        }
        else{
            let err = `Error: ${result.message ?? "Unknown error (-1)"}`
            if (result.message === "server_not_connected"){
                err = `The game server is not connected to RustServerTool (${err})`
            }
            else if (result.message === "server_timeout"){
                err = `The player is not banned or the game server did not respond in time (${err})`
            }
            setError(err);
        }
    };

    return (
        <OverlayBase hide={props.hide} w="w-[28rem]">
            <h2 className="text-xl font-semibold mb-4">Unban '{props.playerName}' ?</h2>
            <div className="mt-6 flex flex-col items-end">
                {error && <p className="text-red-500 text-sm mb-2 text-right">{error}</p>}
                <div className="flex justify-end gap-3">
                    <button onClick={props.hide}
                            className="px-4 py-2 hover:bg-neutral-700 border border-neutral-500 rounded-lg">Cancel
                    </button>
                    <button onClick={handleBan} disabled={loading}
                            className="px-4 py-2 bg-yellow-500 text-black hover:opacity-90 rounded-lg disabled:bg-neutral-600 flex items-center">
                        {loading ? <SvgLoader className="size-5 text-transparent fill-white text-neutral-700 animate-spin inline" /> : "Unban"}
                    </button>
                </div>
            </div>
        </OverlayBase>
    )
}